import { Pipe, PipeTransform } from '@angular/core';
import { digger } from '@cbre/digger';
import { AddressPaths } from './summary-view.component';

@Pipe({
  name: 'companyAddresses',
  standalone: false,
})
export class CompanyAddressesPipe implements PipeTransform {
  transform(companyRecord, opts: { addressPaths: AddressPaths }) {
    if (companyRecord == null) {
      return '';
    }

    const { addressPaths } = opts;
    const arrPath = addressPaths.streetName.split('/')[0];
    const locations = digger(companyRecord, arrPath);
    const locAddressPaths = Object.entries(addressPaths).reduce(
      (acc, [key, val]) => ({
        ...acc,
        [key]: val.split('/').slice(1).join('/'),
      }),
      {}
    );
    return locations
      .map(location =>
        !!digger(location, locAddressPaths['streetName'])
          ? // tslint:disable-next-line
            `${digger(location, locAddressPaths['streetName'])}, ${digger(location, locAddressPaths['city'])} ${digger(
              location,
              locAddressPaths['state']
            )} ${digger(location, locAddressPaths['zip'])}`
          : ''
      )
      .filter(location => !!location)
      .join('; ');
  }
}
